"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * THORChain API
 * This documentation outlines the API for THORChain.  NOTE: This document is a **work in progress**.
 *
 * The version of the OpenAPI document:
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VaultsApi = exports.VaultsApiFactory = exports.VaultsApiFp = exports.VaultsApiAxiosParamCreator = exports.TxApi = exports.TxApiFactory = exports.TxApiFp = exports.TxApiAxiosParamCreator = exports.THORNamesApi = exports.THORNamesApiFactory = exports.THORNamesApiFp = exports.THORNamesApiAxiosParamCreator = exports.QueueApi = exports.QueueApiFactory = exports.QueueApiFp = exports.QueueApiAxiosParamCreator = exports.PoolsApi = exports.PoolsApiFactory = exports.PoolsApiFp = exports.PoolsApiAxiosParamCreator = exports.NodesApi = exports.NodesApiFactory = exports.NodesApiFp = exports.NodesApiAxiosParamCreator = exports.NetworkApi = exports.NetworkApiFactory = exports.NetworkApiFp = exports.NetworkApiAxiosParamCreator = exports.KeygenKeysignApi = exports.KeygenKeysignApiFactory = exports.KeygenKeysignApiFp = exports.KeygenKeysignApiAxiosParamCreator = exports.HealthCheckApi = exports.HealthCheckApiFactory = exports.HealthCheckApiFp = exports.HealthCheckApiAxiosParamCreator = exports.TxStatusEnum = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var TxStatusEnum;
(function (TxStatusEnum) {
    TxStatusEnum["Done"] = "done";
    TxStatusEnum["Incomplete"] = "incomplete";
})(TxStatusEnum = exports.TxStatusEnum || (exports.TxStatusEnum = {}));
/**
 * HealthCheckApi - axios parameter creator
 * @export
 */
const HealthCheckApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/thorchain/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.HealthCheckApiAxiosParamCreator = HealthCheckApiAxiosParamCreator;
/**
 * HealthCheckApi - functional programming interface
 * @export
 */
const HealthCheckApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.HealthCheckApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ping(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.HealthCheckApiFp = HealthCheckApiFp;
/**
 * HealthCheckApi - factory interface
 * @export
 */
const HealthCheckApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.HealthCheckApiFp(configuration);
    return {
        /**
         *
         * @summary Ping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping(options) {
            return localVarFp.ping(options).then((request) => request(axios, basePath));
        },
    };
};
exports.HealthCheckApiFactory = HealthCheckApiFactory;
/**
 * HealthCheckApi - object-oriented interface
 * @export
 * @class HealthCheckApi
 * @extends {BaseAPI}
 */
class HealthCheckApi extends base_1.BaseAPI {
    /**
     *
     * @summary Ping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    ping(options) {
        return exports.HealthCheckApiFp(this.configuration).ping(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.HealthCheckApi = HealthCheckApi;
/**
 * KeygenKeysignApi - axios parameter creator
 * @export
 */
const KeygenKeysignApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve Keygen block from THORChain
         * @summary Get Keygen
         * @param {string} height block height
         * @param {string} pubkey node public key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeygen: (height, pubkey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'height' is not null or undefined
            common_1.assertParamExists('getKeygen', 'height', height);
            // verify required parameter 'pubkey' is not null or undefined
            common_1.assertParamExists('getKeygen', 'pubkey', pubkey);
            const localVarPath = `/thorchain/keygen/{height}/{pubkey}`
                .replace(`{${"height"}}`, encodeURIComponent(String(height)))
                .replace(`{${"pubkey"}}`, encodeURIComponent(String(pubkey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve Keysign information from THORChain
         * @summary Get Keysign
         * @param {string} height block height
         * @param {string} pubkey node public key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeysign: (height, pubkey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'height' is not null or undefined
            common_1.assertParamExists('getKeysign', 'height', height);
            // verify required parameter 'pubkey' is not null or undefined
            common_1.assertParamExists('getKeysign', 'pubkey', pubkey);
            const localVarPath = `/thorchain/keysign/{height}/{pubkey}`
                .replace(`{${"height"}}`, encodeURIComponent(String(height)))
                .replace(`{${"pubkey"}}`, encodeURIComponent(String(pubkey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.KeygenKeysignApiAxiosParamCreator = KeygenKeysignApiAxiosParamCreator;
/**
 * KeygenKeysignApi - functional programming interface
 * @export
 */
const KeygenKeysignApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.KeygenKeysignApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve Keygen block from THORChain
         * @summary Get Keygen
         * @param {string} height block height
         * @param {string} pubkey node public key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeygen(height, pubkey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getKeygen(height, pubkey, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieve Keysign information from THORChain
         * @summary Get Keysign
         * @param {string} height block height
         * @param {string} pubkey node public key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeysign(height, pubkey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getKeysign(height, pubkey, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.KeygenKeysignApiFp = KeygenKeysignApiFp;
/**
 * KeygenKeysignApi - factory interface
 * @export
 */
const KeygenKeysignApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.KeygenKeysignApiFp(configuration);
    return {
        /**
         * Retrieve Keygen block from THORChain
         * @summary Get Keygen
         * @param {string} height block height
         * @param {string} pubkey node public key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeygen(height, pubkey, options) {
            return localVarFp.getKeygen(height, pubkey, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve Keysign information from THORChain
         * @summary Get Keysign
         * @param {string} height block height
         * @param {string} pubkey node public key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeysign(height, pubkey, options) {
            return localVarFp.getKeysign(height, pubkey, options).then((request) => request(axios, basePath));
        },
    };
};
exports.KeygenKeysignApiFactory = KeygenKeysignApiFactory;
/**
 * KeygenKeysignApi - object-oriented interface
 * @export
 * @class KeygenKeysignApi
 * @extends {BaseAPI}
 */
class KeygenKeysignApi extends base_1.BaseAPI {
    /**
     * Retrieve Keygen block from THORChain
     * @summary Get Keygen
     * @param {KeygenKeysignApiGetKeygenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeygenKeysignApi
     */
    getKeygen(requestParameters, options) {
        return exports.KeygenKeysignApiFp(this.configuration).getKeygen(requestParameters.height, requestParameters.pubkey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve Keysign information from THORChain
     * @summary Get Keysign
     * @param {KeygenKeysignApiGetKeysignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeygenKeysignApi
     */
    getKeysign(requestParameters, options) {
        return exports.KeygenKeysignApiFp(this.configuration).getKeysign(requestParameters.height, requestParameters.pubkey, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.KeygenKeysignApi = KeygenKeysignApi;
/**
 * NetworkApi - axios parameter creator
 * @export
 */
const NetworkApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve lastest block infomation across all chains
         * @summary Get all last block height
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLastBlockHeight: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/thorchain/lastblock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve constant values from THORChain
         * @summary Get constant values from THORChain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConstantValuesFromTHORChain: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/thorchain/constants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve current network version from THORChain
         * @summary Get current network version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentNetworkVersion: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/thorchain/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve all the inbound addresses from THORChain
         * @summary Get inbound addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInboundAddresses: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/thorchain/inbound_addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve the last block height information about the request chain
         * @summary Get last block height per chain
         * @param {string} chain chain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastBlockHeightPerChain: (chain, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'chain' is not null or undefined
            common_1.assertParamExists('getLastBlockHeightPerChain', 'chain', chain);
            const localVarPath = `/thorchain/lastblock/{chain}`
                .replace(`{${"chain"}}`, encodeURIComponent(String(chain)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve network data from THORChain
         * @summary Get network data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkData: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/thorchain/network`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get Ragnarok status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRagnarokStatus: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/thorchain/ragnarok`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.NetworkApiAxiosParamCreator = NetworkApiAxiosParamCreator;
/**
 * NetworkApi - functional programming interface
 * @export
 */
const NetworkApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.NetworkApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve lastest block infomation across all chains
         * @summary Get all last block height
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLastBlockHeight(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllLastBlockHeight(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieve constant values from THORChain
         * @summary Get constant values from THORChain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConstantValuesFromTHORChain(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getConstantValuesFromTHORChain(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieve current network version from THORChain
         * @summary Get current network version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentNetworkVersion(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrentNetworkVersion(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieve all the inbound addresses from THORChain
         * @summary Get inbound addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInboundAddresses(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getInboundAddresses(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieve the last block height information about the request chain
         * @summary Get last block height per chain
         * @param {string} chain chain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastBlockHeightPerChain(chain, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLastBlockHeightPerChain(chain, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieve network data from THORChain
         * @summary Get network data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkData(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getNetworkData(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get Ragnarok status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRagnarokStatus(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRagnarokStatus(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.NetworkApiFp = NetworkApiFp;
/**
 * NetworkApi - factory interface
 * @export
 */
const NetworkApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.NetworkApiFp(configuration);
    return {
        /**
         * Retrieve lastest block infomation across all chains
         * @summary Get all last block height
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLastBlockHeight(options) {
            return localVarFp.getAllLastBlockHeight(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve constant values from THORChain
         * @summary Get constant values from THORChain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConstantValuesFromTHORChain(options) {
            return localVarFp.getConstantValuesFromTHORChain(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve current network version from THORChain
         * @summary Get current network version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentNetworkVersion(options) {
            return localVarFp.getCurrentNetworkVersion(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all the inbound addresses from THORChain
         * @summary Get inbound addresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInboundAddresses(options) {
            return localVarFp.getInboundAddresses(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the last block height information about the request chain
         * @summary Get last block height per chain
         * @param {string} chain chain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastBlockHeightPerChain(chain, options) {
            return localVarFp.getLastBlockHeightPerChain(chain, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve network data from THORChain
         * @summary Get network data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkData(options) {
            return localVarFp.getNetworkData(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Ragnarok status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRagnarokStatus(options) {
            return localVarFp.getRagnarokStatus(options).then((request) => request(axios, basePath));
        },
    };
};
exports.NetworkApiFactory = NetworkApiFactory;
/**
 * NetworkApi - object-oriented interface
 * @export
 * @class NetworkApi
 * @extends {BaseAPI}
 */
class NetworkApi extends base_1.BaseAPI {
    /**
     * Retrieve lastest block infomation across all chains
     * @summary Get all last block height
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkApi
     */
    getAllLastBlockHeight(options) {
        return exports.NetworkApiFp(this.configuration).getAllLastBlockHeight(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve constant values from THORChain
     * @summary Get constant values from THORChain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkApi
     */
    getConstantValuesFromTHORChain(options) {
        return exports.NetworkApiFp(this.configuration).getConstantValuesFromTHORChain(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve current network version from THORChain
     * @summary Get current network version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkApi
     */
    getCurrentNetworkVersion(options) {
        return exports.NetworkApiFp(this.configuration).getCurrentNetworkVersion(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all the inbound addresses from THORChain
     * @summary Get inbound addresses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkApi
     */
    getInboundAddresses(options) {
        return exports.NetworkApiFp(this.configuration).getInboundAddresses(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve the last block height information about the request chain
     * @summary Get last block height per chain
     * @param {NetworkApiGetLastBlockHeightPerChainRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkApi
     */
    getLastBlockHeightPerChain(requestParameters, options) {
        return exports.NetworkApiFp(this.configuration).getLastBlockHeightPerChain(requestParameters.chain, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve network data from THORChain
     * @summary Get network data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkApi
     */
    getNetworkData(options) {
        return exports.NetworkApiFp(this.configuration).getNetworkData(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Ragnarok status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkApi
     */
    getRagnarokStatus(options) {
        return exports.NetworkApiFp(this.configuration).getRagnarokStatus(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.NetworkApi = NetworkApi;
/**
 * NodesApi - axios parameter creator
 * @export
 */
const NodesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve the node with given node address from THORChain
         * @summary Get a node
         * @param {string} nodeAddress node address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getANode: (nodeAddress, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'nodeAddress' is not null or undefined
            common_1.assertParamExists('getANode', 'nodeAddress', nodeAddress);
            const localVarPath = `/thorchain/node/{node_address}`
                .replace(`{${"node_address"}}`, encodeURIComponent(String(nodeAddress)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve all nodes that have bond
         * @summary Get all nodes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNodes: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/thorchain/nodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.NodesApiAxiosParamCreator = NodesApiAxiosParamCreator;
/**
 * NodesApi - functional programming interface
 * @export
 */
const NodesApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.NodesApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve the node with given node address from THORChain
         * @summary Get a node
         * @param {string} nodeAddress node address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getANode(nodeAddress, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getANode(nodeAddress, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieve all nodes that have bond
         * @summary Get all nodes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNodes(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllNodes(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.NodesApiFp = NodesApiFp;
/**
 * NodesApi - factory interface
 * @export
 */
const NodesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.NodesApiFp(configuration);
    return {
        /**
         * Retrieve the node with given node address from THORChain
         * @summary Get a node
         * @param {string} nodeAddress node address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getANode(nodeAddress, options) {
            return localVarFp.getANode(nodeAddress, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all nodes that have bond
         * @summary Get all nodes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNodes(options) {
            return localVarFp.getAllNodes(options).then((request) => request(axios, basePath));
        },
    };
};
exports.NodesApiFactory = NodesApiFactory;
/**
 * NodesApi - object-oriented interface
 * @export
 * @class NodesApi
 * @extends {BaseAPI}
 */
class NodesApi extends base_1.BaseAPI {
    /**
     * Retrieve the node with given node address from THORChain
     * @summary Get a node
     * @param {NodesApiGetANodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    getANode(requestParameters, options) {
        return exports.NodesApiFp(this.configuration).getANode(requestParameters.nodeAddress, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all nodes that have bond
     * @summary Get all nodes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodesApi
     */
    getAllNodes(options) {
        return exports.NodesApiFp(this.configuration).getAllNodes(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.NodesApi = NodesApi;
/**
 * PoolsApi - axios parameter creator
 * @export
 */
const PoolsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get a liquidity provider of a pool
         * @param {string} asset The asset of the pool
         * @param {string} address The address of the liquidity provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getALiquidityProviderOfAPool: (asset, address, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'asset' is not null or undefined
            common_1.assertParamExists('getALiquidityProviderOfAPool', 'asset', asset);
            // verify required parameter 'address' is not null or undefined
            common_1.assertParamExists('getALiquidityProviderOfAPool', 'address', address);
            const localVarPath = `/thorchain/pool/{asset}/liquidity_provider/{address}`
                .replace(`{${"asset"}}`, encodeURIComponent(String(asset)))
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a liquidity pool with the given asset
         * @summary Get a pool
         * @param {string} asset The asset of the pool
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAPool: (asset, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'asset' is not null or undefined
            common_1.assertParamExists('getAPool', 'asset', asset);
            const localVarPath = `/thorchain/pool/{asset}`
                .replace(`{${"asset"}}`, encodeURIComponent(String(asset)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all liquidity providers of a pool
         * @param {string} asset The asset of the pool
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLiquidityProvidersOfAPool: (asset, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'asset' is not null or undefined
            common_1.assertParamExists('getAllLiquidityProvidersOfAPool', 'asset', asset);
            const localVarPath = `/thorchain/pool/{asset}/liquidity_providers`
                .replace(`{${"asset"}}`, encodeURIComponent(String(asset)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve all the liquidity pools from THORChain
         * @summary Get all the liquidity pools
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTheLiquidityPools: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/thorchain/pools`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PoolsApiAxiosParamCreator = PoolsApiAxiosParamCreator;
/**
 * PoolsApi - functional programming interface
 * @export
 */
const PoolsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PoolsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get a liquidity provider of a pool
         * @param {string} asset The asset of the pool
         * @param {string} address The address of the liquidity provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getALiquidityProviderOfAPool(asset, address, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getALiquidityProviderOfAPool(asset, address, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieve a liquidity pool with the given asset
         * @summary Get a pool
         * @param {string} asset The asset of the pool
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAPool(asset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAPool(asset, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all liquidity providers of a pool
         * @param {string} asset The asset of the pool
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLiquidityProvidersOfAPool(asset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllLiquidityProvidersOfAPool(asset, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieve all the liquidity pools from THORChain
         * @summary Get all the liquidity pools
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTheLiquidityPools(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllTheLiquidityPools(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PoolsApiFp = PoolsApiFp;
/**
 * PoolsApi - factory interface
 * @export
 */
const PoolsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PoolsApiFp(configuration);
    return {
        /**
         *
         * @summary Get a liquidity provider of a pool
         * @param {string} asset The asset of the pool
         * @param {string} address The address of the liquidity provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getALiquidityProviderOfAPool(asset, address, options) {
            return localVarFp.getALiquidityProviderOfAPool(asset, address, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a liquidity pool with the given asset
         * @summary Get a pool
         * @param {string} asset The asset of the pool
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAPool(asset, options) {
            return localVarFp.getAPool(asset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all liquidity providers of a pool
         * @param {string} asset The asset of the pool
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLiquidityProvidersOfAPool(asset, options) {
            return localVarFp.getAllLiquidityProvidersOfAPool(asset, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all the liquidity pools from THORChain
         * @summary Get all the liquidity pools
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTheLiquidityPools(options) {
            return localVarFp.getAllTheLiquidityPools(options).then((request) => request(axios, basePath));
        },
    };
};
exports.PoolsApiFactory = PoolsApiFactory;
/**
 * PoolsApi - object-oriented interface
 * @export
 * @class PoolsApi
 * @extends {BaseAPI}
 */
class PoolsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get a liquidity provider of a pool
     * @param {PoolsApiGetALiquidityProviderOfAPoolRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolsApi
     */
    getALiquidityProviderOfAPool(requestParameters, options) {
        return exports.PoolsApiFp(this.configuration).getALiquidityProviderOfAPool(requestParameters.asset, requestParameters.address, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a liquidity pool with the given asset
     * @summary Get a pool
     * @param {PoolsApiGetAPoolRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolsApi
     */
    getAPool(requestParameters, options) {
        return exports.PoolsApiFp(this.configuration).getAPool(requestParameters.asset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all liquidity providers of a pool
     * @param {PoolsApiGetAllLiquidityProvidersOfAPoolRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolsApi
     */
    getAllLiquidityProvidersOfAPool(requestParameters, options) {
        return exports.PoolsApiFp(this.configuration).getAllLiquidityProvidersOfAPool(requestParameters.asset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all the liquidity pools from THORChain
     * @summary Get all the liquidity pools
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolsApi
     */
    getAllTheLiquidityPools(options) {
        return exports.PoolsApiFp(this.configuration).getAllTheLiquidityPools(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PoolsApi = PoolsApi;
/**
 * QueueApi - axios parameter creator
 * @export
 */
const QueueApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve the outbound queue information from THORChain
         * @summary Get outbound queue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutboundQueue: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/thorchain/queue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of tx out items in the queue
         * @summary Get outbound queue detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutboundQueueDetail: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/thorchain/queue/outbound`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.QueueApiAxiosParamCreator = QueueApiAxiosParamCreator;
/**
 * QueueApi - functional programming interface
 * @export
 */
const QueueApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.QueueApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve the outbound queue information from THORChain
         * @summary Get outbound queue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutboundQueue(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOutboundQueue(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of tx out items in the queue
         * @summary Get outbound queue detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutboundQueueDetail(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOutboundQueueDetail(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.QueueApiFp = QueueApiFp;
/**
 * QueueApi - factory interface
 * @export
 */
const QueueApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.QueueApiFp(configuration);
    return {
        /**
         * Retrieve the outbound queue information from THORChain
         * @summary Get outbound queue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutboundQueue(options) {
            return localVarFp.getOutboundQueue(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of tx out items in the queue
         * @summary Get outbound queue detail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOutboundQueueDetail(options) {
            return localVarFp.getOutboundQueueDetail(options).then((request) => request(axios, basePath));
        },
    };
};
exports.QueueApiFactory = QueueApiFactory;
/**
 * QueueApi - object-oriented interface
 * @export
 * @class QueueApi
 * @extends {BaseAPI}
 */
class QueueApi extends base_1.BaseAPI {
    /**
     * Retrieve the outbound queue information from THORChain
     * @summary Get outbound queue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    getOutboundQueue(options) {
        return exports.QueueApiFp(this.configuration).getOutboundQueue(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of tx out items in the queue
     * @summary Get outbound queue detail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    getOutboundQueueDetail(options) {
        return exports.QueueApiFp(this.configuration).getOutboundQueueDetail(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.QueueApi = QueueApi;
/**
 * THORNamesApi - axios parameter creator
 * @export
 */
const THORNamesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve THORName from THORChain
         * @summary Get Keygen
         * @param {string} name THORName name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeygen: (name, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'name' is not null or undefined
            common_1.assertParamExists('getKeygen', 'name', name);
            const localVarPath = `/thorchain/thorname/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.THORNamesApiAxiosParamCreator = THORNamesApiAxiosParamCreator;
/**
 * THORNamesApi - functional programming interface
 * @export
 */
const THORNamesApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.THORNamesApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve THORName from THORChain
         * @summary Get Keygen
         * @param {string} name THORName name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeygen(name, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getKeygen(name, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.THORNamesApiFp = THORNamesApiFp;
/**
 * THORNamesApi - factory interface
 * @export
 */
const THORNamesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.THORNamesApiFp(configuration);
    return {
        /**
         * Retrieve THORName from THORChain
         * @summary Get Keygen
         * @param {string} name THORName name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeygen(name, options) {
            return localVarFp.getKeygen(name, options).then((request) => request(axios, basePath));
        },
    };
};
exports.THORNamesApiFactory = THORNamesApiFactory;
/**
 * THORNamesApi - object-oriented interface
 * @export
 * @class THORNamesApi
 * @extends {BaseAPI}
 */
class THORNamesApi extends base_1.BaseAPI {
    /**
     * Retrieve THORName from THORChain
     * @summary Get Keygen
     * @param {THORNamesApiGetKeygenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof THORNamesApi
     */
    getKeygen(requestParameters, options) {
        return exports.THORNamesApiFp(this.configuration).getKeygen(requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.THORNamesApi = THORNamesApi;
/**
 * TxApi - axios parameter creator
 * @export
 */
const TxApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve a tx with the given hash from THORChain
         * @summary Get a tx with given hash
         * @param {string} hash Tx hash of an inbound transaction or outbound transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getATxWithGivenHash: (hash, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'hash' is not null or undefined
            common_1.assertParamExists('getATxWithGivenHash', 'hash', hash);
            const localVarPath = `/thorchain/tx/{hash}`
                .replace(`{${"hash"}}`, encodeURIComponent(String(hash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get tx signers that match the request hash
         * @summary Get tx signers
         * @param {string} hash Tx hash of an inbound transaction or outbound transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxSigners: (hash, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'hash' is not null or undefined
            common_1.assertParamExists('getTxSigners', 'hash', hash);
            const localVarPath = `/thorchain/tx/{hash}/signers`
                .replace(`{${"hash"}}`, encodeURIComponent(String(hash)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.TxApiAxiosParamCreator = TxApiAxiosParamCreator;
/**
 * TxApi - functional programming interface
 * @export
 */
const TxApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.TxApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve a tx with the given hash from THORChain
         * @summary Get a tx with given hash
         * @param {string} hash Tx hash of an inbound transaction or outbound transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getATxWithGivenHash(hash, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getATxWithGivenHash(hash, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get tx signers that match the request hash
         * @summary Get tx signers
         * @param {string} hash Tx hash of an inbound transaction or outbound transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxSigners(hash, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTxSigners(hash, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.TxApiFp = TxApiFp;
/**
 * TxApi - factory interface
 * @export
 */
const TxApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.TxApiFp(configuration);
    return {
        /**
         * Retrieve a tx with the given hash from THORChain
         * @summary Get a tx with given hash
         * @param {string} hash Tx hash of an inbound transaction or outbound transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getATxWithGivenHash(hash, options) {
            return localVarFp.getATxWithGivenHash(hash, options).then((request) => request(axios, basePath));
        },
        /**
         * Get tx signers that match the request hash
         * @summary Get tx signers
         * @param {string} hash Tx hash of an inbound transaction or outbound transaction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxSigners(hash, options) {
            return localVarFp.getTxSigners(hash, options).then((request) => request(axios, basePath));
        },
    };
};
exports.TxApiFactory = TxApiFactory;
/**
 * TxApi - object-oriented interface
 * @export
 * @class TxApi
 * @extends {BaseAPI}
 */
class TxApi extends base_1.BaseAPI {
    /**
     * Retrieve a tx with the given hash from THORChain
     * @summary Get a tx with given hash
     * @param {TxApiGetATxWithGivenHashRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TxApi
     */
    getATxWithGivenHash(requestParameters, options) {
        return exports.TxApiFp(this.configuration).getATxWithGivenHash(requestParameters.hash, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get tx signers that match the request hash
     * @summary Get tx signers
     * @param {TxApiGetTxSignersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TxApi
     */
    getTxSigners(requestParameters, options) {
        return exports.TxApiFp(this.configuration).getTxSigners(requestParameters.hash, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TxApi = TxApi;
/**
 * VaultsApi - axios parameter creator
 * @export
 */
const VaultsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get a vault by pubkey
         * @param {string} pubkey pubkey of the vault
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAVaultByPubkey: (pubkey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pubkey' is not null or undefined
            common_1.assertParamExists('getAVaultByPubkey', 'pubkey', pubkey);
            const localVarPath = `/thorchain/vault/{pubkey}`
                .replace(`{${"pubkey"}}`, encodeURIComponent(String(pubkey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve all current active Asgard vaults from thorchain
         * @summary Get Asgard vaults
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsgardVaults: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/thorchain/vaults/asgard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve all vaults public keys
         * @summary Get vault pubkeys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaultPubkeys: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/thorchain/vaults/pubkeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve all Yggdrasil vaults from THORChain
         * @summary Get Yggdrasil vaults
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYggdrasilVaults: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/thorchain/vaults/yggdrasil`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.VaultsApiAxiosParamCreator = VaultsApiAxiosParamCreator;
/**
 * VaultsApi - functional programming interface
 * @export
 */
const VaultsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.VaultsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get a vault by pubkey
         * @param {string} pubkey pubkey of the vault
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAVaultByPubkey(pubkey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAVaultByPubkey(pubkey, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieve all current active Asgard vaults from thorchain
         * @summary Get Asgard vaults
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsgardVaults(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAsgardVaults(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieve all vaults public keys
         * @summary Get vault pubkeys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaultPubkeys(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getVaultPubkeys(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieve all Yggdrasil vaults from THORChain
         * @summary Get Yggdrasil vaults
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYggdrasilVaults(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getYggdrasilVaults(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.VaultsApiFp = VaultsApiFp;
/**
 * VaultsApi - factory interface
 * @export
 */
const VaultsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.VaultsApiFp(configuration);
    return {
        /**
         *
         * @summary Get a vault by pubkey
         * @param {string} pubkey pubkey of the vault
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAVaultByPubkey(pubkey, options) {
            return localVarFp.getAVaultByPubkey(pubkey, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all current active Asgard vaults from thorchain
         * @summary Get Asgard vaults
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsgardVaults(options) {
            return localVarFp.getAsgardVaults(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all vaults public keys
         * @summary Get vault pubkeys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaultPubkeys(options) {
            return localVarFp.getVaultPubkeys(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all Yggdrasil vaults from THORChain
         * @summary Get Yggdrasil vaults
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getYggdrasilVaults(options) {
            return localVarFp.getYggdrasilVaults(options).then((request) => request(axios, basePath));
        },
    };
};
exports.VaultsApiFactory = VaultsApiFactory;
/**
 * VaultsApi - object-oriented interface
 * @export
 * @class VaultsApi
 * @extends {BaseAPI}
 */
class VaultsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Get a vault by pubkey
     * @param {VaultsApiGetAVaultByPubkeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    getAVaultByPubkey(requestParameters, options) {
        return exports.VaultsApiFp(this.configuration).getAVaultByPubkey(requestParameters.pubkey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all current active Asgard vaults from thorchain
     * @summary Get Asgard vaults
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    getAsgardVaults(options) {
        return exports.VaultsApiFp(this.configuration).getAsgardVaults(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all vaults public keys
     * @summary Get vault pubkeys
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    getVaultPubkeys(options) {
        return exports.VaultsApiFp(this.configuration).getVaultPubkeys(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all Yggdrasil vaults from THORChain
     * @summary Get Yggdrasil vaults
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    getYggdrasilVaults(options) {
        return exports.VaultsApiFp(this.configuration).getYggdrasilVaults(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.VaultsApi = VaultsApi;
